import styled from '@emotion/styled';

import {Logo as LogoStyle, TextDefault} from '../../styles';

import {Divider as MuiDivider} from '@mui/joy';
import {Link} from 'react-router-dom';

export const SideBarContainer = styled.div`
  margin-left: ${({theme}) => theme.margin.desktop.xl};
  min-width: 240px;
  height: calc(100vh - ${({theme}) => theme.margin.desktop.xl}*2);
  min-height: calc(100vh - ${({theme}) => theme.margin.desktop.xl}*2);
  background-color: ${({theme}) => theme.color.surface.niv1};
  border: 2px solid ${({theme}) => theme.color.white};
  box-shadow: ${({theme}) => theme.boxShadow.primary};
  border-radius: ${({theme}) => theme.border.radius.md};
  display: flex;
  flex-direction: column;
  position: sticky;
  top: ${({theme}) => theme.margin.desktop.xl};
  align-self: flex-start;
  overflow-y: auto;
`;

export const TopSection = styled(Link)`
  display: flex;
  gap: ${({theme}) => theme.gap.desktop.md};
  padding: ${({theme}) => theme.padding.desktop.md};
  text-decoration: none;
`;

export const Logo = styled(LogoStyle)`
  width: 40px;
  height: 40px;
`;

export const LenderName = styled(TextDefault)`
  align-self: center;
`;

export const MenuSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const TopMenuSection = styled.div`
  display: flex;
  margin: ${({theme}) => theme.margin.desktop.lg} 0;
`;

export const BottomMenuSection = styled.div`
  display: flex;
  margin-top: auto;
  margin-bottom: ${({theme}) => theme.margin.desktop.lg};
`;

export const BottomMenuSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xl};
  width: 100%;
`;

export const Divider = styled(MuiDivider)`
  background-color: ${({theme}) => theme.color.neutral.grey_200};
  height: 1px;
`;
